'use strict'

import format from 'string-format'

import {ModelBase} from "./base"

class Sample extends ModelBase {

	static empty_sample = new Sample({
		empty: true,

		id: null,
		name: null,
		patient: null,
		type: null,
		projects: [],
		notes: null,
	})

	constructor(data) {
		super(data)
	}
}

export {Sample}